import { FORM_TRANSPORT, NEXT_FIELD, TRANSPORT_FIELD } from '@/lib/forms/form-transport';

/**
 * Lets a React form post natively when its script is not attached yet. The
 * form also carries `action` and `method="post"`: a visitor who submits before
 * hydration (autofill makes that fast on a heavy page) otherwise sent a GET to
 * the same page, lost the lead and put their name and email in the URL (26
 * page views Sep 10 to Oct 1, 2026). With these fields the route treats it like
 * the noscript twin: delivers it and redirects to `next`. Once hydrated, the
 * submit handler builds its own JSON payload, so these never reach it.
 */
export function FormFallbackFields({ next }: { next: string }) {
  return (
    <>
      <input type="hidden" name={TRANSPORT_FIELD} value={FORM_TRANSPORT.html} />
      <input type="hidden" name={NEXT_FIELD} value={next} />
    </>
  );
}
